export default {
  'menu.welcome': '欢迎',
  'menu.workbench': '工作台',
  'menu.workbench.today-overview': '今日概览',
  'menu.home': '首页',
  'menu.system': '系统设置',
  'menu.system.menu': '菜单管理',
  'menu.system.role': '角色管理',
  'menu.system.user': '用户管理',
  'menu.system.admin-account': '后台账号',
  'menu.system.coach': '教练管理',
  'menu.system.logger': '日志查询',
  'menu.account.settings': '个人设置',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.member': '会员管理',
  'menu.member_ops.member-wods': '会员WOD',
  'menu.member_ops.member-prs': '会员PR',
  'menu.member_injury': '伤病管理',
  'menu.member_ops': '会员运营',
  'menu.member_ops.member-list': '会员列表',
  'menu.member_ops.member-injury': '会员伤病',
  'menu.member_ops.member-movement-library': '会员动作库',
  'menu.member_ops.member-feature': '会员功能',
  'menu.card_collection': '卡种与收款',
  'menu.card_collection.card-templates': '卡种中心',
  'menu.card_collection.card-instance-center': '卡实例中心',
  'menu.card_collection.pause-operation-center': '停复卡处理中心',
  'menu.card_collection.transaction-order-center': '交易订单中心',
  'menu.card_collection.payment-reconciliation': '支付与对账',
  'menu.course_ops': '课程与履约',
  'menu.course_ops.course-schedule': '课程排期',
  'menu.training_content': '训练内容',
  'menu.training_content.wod-template': 'WOD 模板',
  'menu.training_content.movement-library': '动作库',
  'menu.training_content.accessories': '护具',
  'menu.training_content.fitness-mappings': '能力模型映射',
  'menu.training_content.media-assets': '媒体素材',
  'menu.mini_ai': '小程序与 AI',
  'menu.mini_ai.ai-video-review': 'AI 视频审核',
  'menu.mini_ai.wx-share-config': '小程序分享配置',
  'menu.mini_ai.wx-mini-qrcode': '小程序二维码',
  'menu.movements': '动作管理',
  'menu.movements.index': '动作',
  'menu.movements.accessories': '护具',
  'menu.movements.fitness-mappings': '能力模型映射',
  'menu.movements.member-videos': '会员动作库审核',
  'menu.medias': '媒体管理',
  'menu.wod': 'Wod管理',
  'menu.course_schedule': '课程排期',
  'menu.ai_video': 'AI视频',
  'menu.wx_share_config': '小程序分享配置',
  'menu.wx_mini_qrcode': '小程序二维码',
  'menu.training_content.fitness-virtual-avatar-configs': '虚拟人配置',
};
